<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
</div>
<div class="container-fluid py-4">
    <div class="card">
      <div class="card-header">
        <h3 class="text-center">Customers</h3>
        <div class="card-tools">
          <a
            [routerLink]="['/billing/invoices/contacts/add']"
            class="btn btn-dark btn-sm btn-new"
          >
            New customer
          </a>
          <a
            [routerLink]="['/billing/invoices']"
            class="btn btn-dark btn-sm btn-new"
          > back
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Company</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Accounts receivable</th>
                <th>Unused credits</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of data">
                <td>{{ item.contact_name }}</td>
                <td>{{ item.company_name }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.outstanding_receivable_amount_bcy }}</td>
                <td>{{ item.unused_credits_receivable_amount_bcy }}</td>
                <td>
                  <span
                    class="badge"
                    [ngClass]="item.status ? 'badge-success' : 'badge-danger'"
                  >
                    {{ item.status ? "Active" : "Inactive" }}
                  </span>
                </td>
                <td>
                  <a
                    [routerLink]="['/billing/invoices/contacts/edit', item.contact_id]"
                    class="btn btn-link text-dark btn-sm btn-del"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <button
                    (click)="deleteData(item.contact_id)"
                    class="btn btn-link text-dark btn-sm btn-del"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  